/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../helpers'

type Props = {
  className: string
  header?: string[]
  data?: any[]
}

const TablesWidget10: React.FC<Props> = ({className, header, data}) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>Costo Minutas</span>
          {/* <span className='text-muted mt-1 fw-bold fs-7'>Over 500 members</span> */}
        </h3>
        <div
          className='card-toolbar'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Click to add a user'
        >
          <Link
            to='/minutas/minutalist'
            className='btn btn-sm btn-light-primary'
            // data-bs-toggle='modal'
            // data-bs-target='#kt_modal_invite_friends'
          >
            <KTSVG path='media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
            Ver Más
          </Link>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed  align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted'>
                {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div>
                </th> */}
                {
                  !!header &&
                  !!header.length &&
                  header.map((item: any, i: number) => {
                    return (
                      <th className='min-w-120px' key={i}>
                        {item}
                      </th>
                    )
                  })
                }

                {!header && (
                  <>
                    <th className='min-w-120px'>#</th>
                    <th className='min-w-120px'>Marzo</th>
                    <th className='min-w-120px'>Abril</th>
                    <th className='min-w-120px'>Mayo</th>
                    <th className='min-w-120px'>Junio</th>
                  </>
                )}
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {
                !!data &&
                !!data.length &&
                data.map((row: any[], index: number) => {
                  return (
                    <tr key={index}>
                      {
                        row.map((column: any, i: number) => {
                          return (
                            <td key={i}>
                              { i === 0 &&
                                <div className='d-flex align-items-center'>
                                  <div className='d-flex justify-content-start flex-column'>
                                    <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                                    
                                      {row[0]}
                                    </a>
                                  </div>
                                </div>
                              }
                              { i !== 0 &&
                                <span className='fw-bold'>{column}</span>
                              }
                            </td>
                          )
                        })
                      } 
                    </tr>
                  )
                })
              }
                
              {(!data || !data.length) && (
                <>
                  <tr>
                    {/* <td>
                      <div className='form-check form-check-sm form-check-custom form-check-solid'>
                        <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                      </div>
                    </td> */}
                    <td>
                      <div className='d-flex align-items-center'>
                        {/* <div className='symbol symbol-45px me-5'>
                          <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
                        </div> */}
                        <div className='d-flex justify-content-start flex-column'>
                          <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                            Minuta sobre costo AMD
                          </a>
                          {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                            HTML, JS, ReactJS
                          </span> */}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className='fw-bold'>2000</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>1940</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>1843</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>1713</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                  </tr>
                  <tr>
                    {/* <td>
                      <div className='form-check form-check-sm form-check-custom form-check-solid'>
                        <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                      </div>
                    </td> */}
                    <td>
                      <div className='d-flex align-items-center'>
                        {/* <div className='symbol symbol-45px me-5'>
                          <img src={toAbsoluteUrl('/media/avatars/300-2.jpg')} alt='' />
                        </div> */}
                        <div className='d-flex justify-content-start flex-column'>
                          <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                            Minuta sobre costo sitio
                          </a>
                          {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                            C#, ASP.NET, MS SQL
                          </span> */}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className='fw-bold'>2000</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>1940</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>1843</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>1713</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                  </tr>
                  <tr>
                    {/* <td>
                      <div className='form-check form-check-sm form-check-custom form-check-solid'>
                        <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                      </div>
                    </td> */}
                    <td>
                      <div className='d-flex align-items-center'>
                        {/* <div className='symbol symbol-45px me-5'>
                          <img src={toAbsoluteUrl('/media/avatars/300-5.jpg')} alt='' />
                        </div> */}
                        <div className='d-flex justify-content-start flex-column'>
                          <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                            Minuta en costo AMD
                          </a>
                          {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                            PHP, Laravel, VueJS
                          </span> */}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className='fw-bold'>3000</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>2910</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>2764</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>2570</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                  </tr>
                  <tr>
                    {/* <td>
                      <div className='form-check form-check-sm form-check-custom form-check-solid'>
                        <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                      </div>
                    </td> */}
                    <td>
                      <div className='d-flex align-items-center'>
                        {/* <div className='symbol symbol-45px me-5'>
                          <img src={toAbsoluteUrl('/media/avatars/300-20.jpg')} alt='' />
                        </div> */}
                        <div className='d-flex justify-content-start flex-column'>
                          <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                            Minuta en costo sitio
                          </a>
                          {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                            Python, PostgreSQL, ReactJS
                          </span> */}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className='fw-bold'>2600</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>2510</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>2340</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>2133</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                  </tr>
                  <tr>
                    {/* <td>
                      <div className='form-check form-check-sm form-check-custom form-check-solid'>
                        <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                      </div>
                    </td> */}
                    <td>
                      <div className='d-flex align-items-center'>
                        {/* <div className='symbol symbol-45px me-5'>
                          <img src={toAbsoluteUrl('/media/avatars/300-23.jpg')} alt='' />
                        </div> */}
                        <div className='d-flex justify-content-start flex-column'>
                          <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                            Minuta bajo costo AMD
                          </a>
                          {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                            HTML, JS, ReactJS
                          </span> */}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className='fw-bold'>100</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>102</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>90</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                    <td>
                      <span className='fw-bold'>70</span>
                      {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                        Web, UI/UX Design
                      </span> */}
                    </td>
                  </tr>
                </>
              )}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export {TablesWidget10}
